import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const jobsPlugin = createPlugin({
  id: 'jobs',
  routes: {
    root: rootRouteRef,
  },
});

export const JobsPage = jobsPlugin.provide(
  createRoutableExtension({
    name: 'JobsPage',
    component: () => import('./components/IndexPage').then(m => m.IndexPage),
    mountPoint: rootRouteRef,
  }),
);
